{
    "Addusertitle": "Adicionar conta de usuário do aplicativo",
    "Modifyusertitle": "Modificar conta de usuário do aplicativo",
    "PermissionsTitle": "Permissões",
    "ExtensionTitle": "Extensão\/Ponto Final",
    "ReportingTitle": "Comunicando",
    "AdministratorTitle": "Administrador",
    "RoleTitle": "Função",
    "SettingsTitle": "Definições",
    "ValidationWarning": "Corrija os erros antes de terminar",
    "ServerErrorTitle": "Erros de validação",
    "MonthlyBillingWarning": "AVISO: afeta o faturamento mensal",
    "UnknownOrDeleted": "[Desconhecido ou Excluído]",
    "AddUserLanguage_ButtonHelpLabel": "Ajuda?",
    "AddUserLanguage_ButtonSubmitLabel": "Salvar",
    "AddUserLanguage_ButtonCancelLabel": "Cancelar",
    "AddUserLanguage_PromptMessage": "Tem certeza de que deseja fechar esta janela? Todas as configurações modificadas serão perdidas quando fechadas.",
    "AddUserLanguage_PromptConfirm": "sim",
    "AddUserLanguage_PromptCancel": "Cancelar",
    "AddUserLanguage_DetailsTitle": "Detalhes do usuario",
    "NAME": "AddUserLanguage",
    "APIKeys_Title": "Chaves de API"
}